import styles from './UpsertProjectModal.module.css';

import { projectsStore } from '../../../../store/mobx/projects.store';
import TextField from 'ui/TextField';
import TextArea from '../../../../ui/TextArea';
import Modal from '../../../../ui/Modal';
import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import useAlert from 'hooks/useAlert';
import FormTextField from 'ui/formItems/FormTextField';
import FormTextArea from 'ui/formItems/FormTextArea';

const UpsertProjectModal = ({ setModalOpened }) => {
  const { showAlert } = useAlert();
  const { upsertProject, selectedProject } = projectsStore;

  const form = useForm({
    defaultValues: {
      name: selectedProject?.name ?? '',
      code: selectedProject?.code ?? '',
      goal: selectedProject?.goal ?? '',
      task: selectedProject?.task ?? '',
      description: selectedProject?.description ?? '',
    },
  });

  const {
    handleSubmit,
    formState: { errors },
    setValue,
    register,
  } = form;

  const submitForm = async (data) => {
    const response = await upsertProject({
      id: selectedProject?.id,
      ...data,
    });

    if (!response.success && response.error_code === 2040) return alarmNameNotUniqueAlert();
    if (!response.success && response.error_code)
      return errorCommonAlert(response.error_code, response.error);

    closeModal();
    successUpsertAlert();
  };

  const closeModal = () => setModalOpened(false);

  const successUpsertAlert = () => {
    showAlert(
      selectedProject?.id ? 'Проект обновлен успешно!' : 'Проект добавлен успешно!',
      'success',
    );
  };

  const alarmNameNotUniqueAlert = () => {
    showAlert(`Проект с таким именем уже существует!`, 'error');
  };

  const errorCommonAlert = (code, message) => {
    showAlert(` Код № ${code}${message ? ` - ${message}` : ''}!`, 'error');
  };

  return (
    <Modal
      title={`${selectedProject?.id ? 'Редактировать' : 'Добавить'} проект`}
      onSubmit={handleSubmit(submitForm)}
      onClose={closeModal}
    >
      <FormProvider {...form}>
        <FormTextField name="name" label={'Название'} required />
        <FormTextField name="code" label="Шифр" required />
        <FormTextArea
          className={styles.textAreaField}
          label="Цели"
          name="goal"
          placeholder="Введите данные"
        />
        <FormTextArea
          className={styles.textAreaField}
          label="Задачи"
          name="task"
          placeholder="Введите данные"
        />
        <FormTextArea
          className={styles.textAreaField}
          label="Аннотации"
          name="description"
          placeholder="Введите данные"
        />
      </FormProvider>
    </Modal>
  );
};

export default UpsertProjectModal;
